module.exports = __webpack_public_path__ + "img/bg.4dbbb5c0.png";